import React from 'react';
import { observer, inject } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
// import NotificationToast from './NotificationToast';
import { Position, Toast, Toaster } from '@blueprintjs/core';
// import { INTENT_PRIMARY, INTENT_DANGER } from '@blueprintjs/core/lib/esm/common/classes';
import styled from '@emotion/styled';
import { PushNotificationStore } from '../../store/PushNotificationStore';

interface PushNotificationProps {
  // hubConnection?: any;
  PushNotificationStore?: Instance<typeof PushNotificationStore>;
  user?: string;
}

interface PushNotificationState {
  nick: string;
  message?: string;
  messages?: string[];
  toasts?: any[];
  userCnt?: number;
}

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  .bp3-button {
    margin-right: 3px;
  }
`;

@inject('PushNotificationStore')
@observer
class PushNotification extends React.Component<PushNotificationProps, PushNotificationState> {
  state = {
    nick: '',
    message: '',
    messages: [],
    toasts: [],
    userCnt: 0,
  } as PushNotificationState;

  private toaster: Toaster;
  private refHandlers = {
    toaster: (ref: Toaster) => (this.toaster = ref),
  };

  // async componentDidMount()  {
  //   console.log(config.hubUrl);
  // if (this.state.hubConnection ==  null) {
  // const hubConnection = new signalR.HubConnectionBuilder().withUrl(config.hubUrl).build(); // 'http://localhost:5001/pharmagardeHub').build();
  // hubConnection.on("ReceiveMessage", this.receiveMessage);
  // hubConnection.on("ReceiveUserCount", this.receiveUserCount);

  // hubConnection.start().then(function () {
  //         return console.log("SignalR connected");
  //     }).catch(function (err) {
  //         return console.error(err.toString());
  //     });
  // this.setState({ nick: 'jll', hubConnection: hubConnection });
  // }
  // };

  // receiveUserCount = (userCount) => {
  //   // var msg = message.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  //   // var encodedMsg = user + " says " + msg;
  //   // this.setState({ message: encodedMsg });
  //   // NotificationToast.openNotification("Notification", encodedMsg);
  //   // var tst = this.state.toasts!;
  //   // tst.push({ message: encodedMsg, intent: "danger", timeout: 1000});
  //   // this.toaster.show({ message: userCount });
  //   this.setState({ userCnt: userCount});
  // }

  // receiveMessage = (user, message) => {
  //   var msg = message.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  //   var encodedMsg = user + " says " + msg;
  //   this.setState({ message: encodedMsg });
  //   // NotificationToast.openNotification("Notification", encodedMsg);
  //   var tst = this.state.toasts!;
  //   // tst.push({ message: encodedMsg, intent: "danger", timeout: 1000});
  //   this.toaster.show({ message: encodedMsg });
  //   this.setState({ toasts: tst});
  // }

  private addToast = (message) => {
    this.toaster.show({ message: message });
  };

  render() {
    const { userCnt } = this.state;
    const cnt = this.props.PushNotificationStore!.userCount;
    const message = this.props.PushNotificationStore!.message;
    if (message != '') {
      // this.state.toasts!.push({ message: message, intent: "INTENT_PRIMARY", timeout: 1000})
      this.addToast(message);
    }
    // if (hubConnection) {
    //   hubConnection.start().then(function () {
    //       return console.log("SignalR connected");
    //   }).catch(function (err) {
    //       return console.error(err.toString());
    //   });
    //   // hubConnection.invoke("SendMessage","jll","My message");
    // }

    return (
      <DivLine>
        {/* Utilisateurs connectés: {cnt}&nbsp;&nbsp;&nbsp; */}
        {/* <Button onClick={this.addToast} text="Test PushNotification" /> */}
        <Toaster position={Position.TOP} ref={this.refHandlers.toaster}>
          {/* "Toasted!" will appear here after clicking button. */}
          {this.state.toasts!.map((toast) => (
            <Toast {...toast} />
          ))}
        </Toaster>
      </DivLine>
    );
  }
}

export default PushNotification;
